import React from 'react';
import { SVGIconProps } from '../../domains/common';

const PinterestIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 -4 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_1904_58044)">
        <path
          d="M11.9987 0C5.37231 0 0 5.37181 0 11.9982C0 16.9111 2.9543 21.1317 7.18197 22.9874C7.14812 22.1496 7.17584 21.1438 7.39073 20.2323C7.62144 19.2582 8.93469 13.6945 8.93469 13.6945C8.93469 13.6945 8.55128 12.9285 8.55128 11.7961C8.55128 10.0182 9.58196 8.69028 10.8653 8.69028C11.9567 8.69028 12.484 9.51 12.484 10.4915C12.484 11.5886 11.7842 13.2296 11.4243 14.7495C11.1237 16.0222 12.0625 17.0603 13.3181 17.0603C15.5914 17.0603 17.1225 14.1406 17.1225 10.6813C17.1225 8.05169 15.3513 6.08343 12.1299 6.08343C8.49032 6.08343 6.22283 8.79759 6.22283 11.8293C6.22283 12.8745 6.53111 13.6118 7.01387 14.1825C7.23584 14.4447 7.26662 14.5503 7.18625 14.8513C7.12879 15.072 6.99656 15.6035 6.9419 15.8142C6.86196 16.118 6.61577 16.2266 6.34107 16.1144C4.66469 15.4301 3.88396 13.5943 3.88396 11.5306C3.88396 8.12244 6.7585 4.0356 12.4592 4.0356C17.0401 4.0356 20.0551 7.35048 20.0551 10.9087C20.0551 15.6153 17.4384 19.1316 13.5812 19.1316C12.2858 19.1316 11.0672 18.4313 10.6499 17.6361C10.6499 17.6361 9.9533 20.4005 9.80576 20.9343C9.55144 21.8594 9.05346 22.7839 8.59816 23.5045C9.67729 23.8231 10.8172 23.9965 11.9987 23.9965C18.6244 23.9965 23.9965 18.6247 23.9965 11.9982C23.9965 5.37181 18.6244 0 11.9987 0Z"
          fill={colored ? '#CB2026' : '#365284'}
        />
      </g>
    </svg>
  );
};

export default PinterestIcon;
